import { render, staticRenderFns } from "./ChooseSiteLang.vue?vue&type=template&id=3a9de1bc"
import script from "./ChooseSiteLang.vue?vue&type=script&lang=ts"
export * from "./ChooseSiteLang.vue?vue&type=script&lang=ts"
import style0 from "./ChooseSiteLang.vue?vue&type=style&index=0&id=3a9de1bc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports